export function toggleClassByCategory(target: HTMLElement, className: string, categoryList: string[]) {
    if (!target) return;

    categoryList.forEach(cls => {
        if (cls !== className && target.classList.contains(cls)) {
            target.classList.remove(cls);
        }
    });

    if (target.classList.contains(className)) {
        target.classList.remove(className);
    } else {
        target.classList.add(className);
    }
}